<div id="office_search">
  <form *ngIf="questionForm">
    <tgf-form-control-question-processor
      [form]="questionForm"
      [questionJson]="questionJson"
      [parentModel]="actualModel"
      [questionsToSkip]="['NRDS']">
    </tgf-form-control-question-processor>
    <ng-container *ngIf="questionForm.get('nrds_search')?.value !== 'NOTNAR'">
      <div class="d-flex"
           *ngIf="questionForm?.get('nrds_search')?.value &&
          questionForm?.get('nrds_search')?.value !== 'NOTNAR'">
        <button type="button" class="sd-btn sd-btn--action me-2"
                (click)="searchM1Member()">
          Search NRDS
        </button>
        <p *ngIf="isValidM1Member"
           class="success-message"
        ><i class="color-success fa-solid fa-circle-check me-2"
        ></i>NRDS records have been found, please select your NRDS record below.</p>
      </div>
      <p *ngIf="questionForm.get('nrds_search')?.value &&
     questionForm.get('nrds_search')?.value !== 'NOTNAR'"
      >Once you have completed an option above, click 'search NRDS'.</p>

      <tgf-form-control-question-processor
        class="pt-3"
        [questionsToInclude]="['NRDS']"
        [parentModel]="actualModel"
        [form]="questionForm"
        [questionJson]="questionJson">
      </tgf-form-control-question-processor>
    </ng-container>
  </form>
</div>

<tg-spinner [blockAll]="true" *ngIf="isItLoading()"></tg-spinner>
